import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { toTitleCase } from 'utils/toTitleCase';
import Button from '../../../components/Button';
import Header from '../../../components/Header';
import Validator from '../../../components/Validator';
import imgDeclined from '../../../assets/images/declined.svg';
import schema from './schema';
import Input from '../../../components/Form/Input';
import Progress from '../../../components/Progress';
import ApplicationId from '../../../components/ApplicationId';
import {
  newNextAction,
  NEW_NEXT,
} from '../../../actions/navigation';
import { useConfig } from '../../../config/ConfigContext';

const RepromptLastName = (props) => {
  const config = useConfig();
  const { navigate, checkinData, params, searchParams } = props;
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [prevLastname, setPrevLastname] = useState(null);
  const [uploadingPercentage, setUploadingPercentage] = useState(null);
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');
  const test = searchParams.get('test');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      if (test) {
        navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}&test=${test}`);
      } else {
        navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
      }
    } else {
      setPrevLastname(checkinData.data.data.lastName ? `${checkinData.data.data.lastName}` : null);
    }
  }, []);

  useEffect(() => {
    const { fetch } = props;

    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(routeUrl);
    }
  }, [props.checkinData]);

  const handleSubmitFrom = (e) => {
    e.preventDefault();
    const { dispatch, validator: { values } } = props;

    setIsProgressVisible(true);

    if (test) {
      dispatch(newNextAction({
        key,
        workflowType: workflowType || 'text2apply',
        data: {
          test,
          lastName: values.lastname,
        },
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
      }));
    } else {
      dispatch(newNextAction({
        key,
        workflowType: workflowType || 'text2apply',
        data: {
          test,
          lastName: values.lastname,
        },
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
      }));
    }
  };

  const handleInputChange = (event) => {
    const { validator: { onChangeHandler } } = props;
    onChangeHandler(event.target.name, (event.target.value).replace(/[^a-zA-Z '-]/g, ''));
  };

  const handleBlur = (event) => {
    event.preventDefault();

    const { validator: { onChangeHandler } } = props;
    onChangeHandler(event.target.name, toTitleCase(event.target.value));
  };

  const { validator: { values, errors } } = props;

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(props.checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      <div className="content">
        <img src={imgDeclined} alt="" />
        <h1 style={{ margin: 0 }}>We had a difficult time verifying you</h1>
        <div className="container">
          <div className="row">
            <div className="col">
              <h3 style={{ marginBottom: 20 }}>Please Re-enter Your Last Name</h3>
              {
                prevLastname
                  && (
                  <p>
                    You entered
                    {' '}
                    {prevLastname}
                  </p>
                  )
              }
              <div className="form-group">
                <Input
                  label="Last Name"
                  name="lastname"
                  value={values.lastname ? `${values.lastname}` : ''}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  hasError={errors.lastname}
                  isRequired
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col">
            <Button
              className="btn btn-primary arrow"
              title="Submit"
              onClick={handleSubmitFrom.bind(null)}
            />
          </div>
        </div>
      </div>
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </div>
  );
};

RepromptLastName.propTypes = {
  navigate: PropTypes.func.isRequired,
  validator: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default Validator(schema)(connect(mapStateToProps)(RepromptLastName));
